import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SwiperModule } from 'swiper/angular';
import { BrowserModule } from '@angular/platform-browser';
import { RecaptchaModule } from 'ng-recaptcha';

// common
import { HeaderTwoComponent } from './common/headers/header-two/header-two.component';
import { MegaMenuComponent } from './common/headers/mega-menu/mega-menu.component';
import { NavMenuComponent } from './common/headers/nav-menu/nav-menu.component';
import { FooterWithBgComponent } from './common/footers/footer-with-bg/footer-with-bg.component';
import { HeaderThreeComponent } from './common/headers/header-three/header-three.component';
import { FooterComponent } from './common/footers/footer/footer.component';
import { FooterThreeComponent } from './common/footers/footer-three/footer-three.component';
import { HeaderEightComponent } from './common/headers/header-eight/header-eight.component';
import { FooterTwoComponent } from './common/footers/footer-two/footer-two.component';
import { FooterFourComponent } from './common/footers/footer-four/footer-four.component';
import { FooterSixComponent } from './common/footers/footer-six/footer-six.component';
import { FooterFiveComponent } from './common/footers/footer-five/footer-five.component';
import { FooterSevenComponent } from './common/footers/footer-seven/footer-seven.component';
import { FooterEightComponent } from './common/footers/footer-eight/footer-eight.component';
import { HeaderTwelveComponent } from './common/headers/header-twelve/header-twelve.component';
import { HeaderThirteenComponent } from './common/headers/header-thirteen/header-thirteen.component';
import { FooterNineComponent } from './common/footers/footer-nine/footer-nine.component';
import { HeaderFourteenComponent } from './common/headers/header-fourteen/header-fourteen.component';

// home component
import { HomeMainComponent } from './home/home-main/home-main.component';
import { HeroAreaComponent } from './home/hero-area/hero-area.component';
import { FeatureOneComponent } from './home/feature-one/feature-one.component';
import { FeatureTwoComponent } from './home/feature-two/feature-two.component';
import { FeatureThreeComponent } from './home/feature-three/feature-three.component';
import { UseableToolsComponent } from './home/useable-tools/useable-tools.component';
import { FancyBannerComponent } from './home/fancy-banner/fancy-banner.component';
import { FaqAreaComponent } from './home/faq-area/faq-area.component';

// customer support
import { HeaderFourComponent } from './common/headers/header-four/header-four.component';

// Product LandingMain
import { HeaderFiveComponent } from './common/headers/header-five/header-five.component';
import { ContactModalComponent } from './common/modals/contact-modal/contact-modal.component';
import { VideoModalComponent } from './common/modals/video-modal/video-modal.component';

// Product Landing Dark
import { HeaderSixComponent } from './common/headers/header-six/header-six.component';

// pipe
import { SafePipe } from './pipe/safe.pipe';

// note taking
import { HeaderSevenComponent } from './common/headers/header-seven/header-seven.component';

// appointment scheduling
import { HeaderNineComponent } from './common/headers/header-nine/header-nine.component';

import { HeaderElevenComponent } from './common/headers/header-eleven/header-eleven.component';

import { ImagePopupComponent } from './common/modals/image-popup/image-popup.component';

import { LoginPageComponent } from './login-page/login-page.component';
// register
import { RegisterPageComponent } from './register-page/register-page.component';
// error page
import { ErrorPageComponent } from './error-page/error-page.component';
// blog v1
import { SearchPropertyComponent } from './search-property/search-property.component';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { BillDetailsComponent } from './bill-details/bill-details.component';
import { SucessComponent } from './sucess/sucess.component';
import { FaildComponent } from './faild/faild.component';
import { PropertyDetailComponent } from './property-detail/property-detail.component';
import { RegisterPropertyComponent } from './register-property/register-property.component';
import { UserPropertyListComponent } from './user-property-list/user-property-list.component';
import { UserPropertyDetailComponent } from './user-property-detail/user-property-detail.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { PaymentDetailComponent } from './payment-detail/payment-detail.component';
import { IndexComponent } from './index/index.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    SwiperModule,
    BrowserModule,
    NgbModule,
    NgbPaginationModule,
    RecaptchaModule
  ],
  declarations: [
    // pipe
    SafePipe,
    // common components
    HeaderTwoComponent,
    MegaMenuComponent,
    NavMenuComponent,
    HeaderThreeComponent,
    FooterComponent,
    FooterThreeComponent,
    HeaderFourComponent,
    FooterFourComponent,
    HeaderFiveComponent,
    ContactModalComponent,
    VideoModalComponent,
    FooterFiveComponent,
    HeaderSixComponent,
    FooterTwoComponent,
    FooterSixComponent,
    HeaderSevenComponent,
    FooterEightComponent,
    FooterSevenComponent,
    HeaderEightComponent,
    HeaderNineComponent,
    HeaderElevenComponent,
    HeaderTwelveComponent,
    HeaderThirteenComponent,
    FooterNineComponent,
    HeaderFourteenComponent,
    FooterWithBgComponent,

    // home components
    HomeMainComponent,
    HeroAreaComponent,
    FeatureOneComponent,
    FeatureTwoComponent,
    FeatureThreeComponent,
    UseableToolsComponent,
    FancyBannerComponent,
    FaqAreaComponent,



    ImagePopupComponent,




    // LoginPageComponent
    LoginPageComponent,
    // register
    RegisterPageComponent,
    // error page
    ErrorPageComponent,
    // blog v1
    SearchPropertyComponent,
    BillDetailsComponent,
    SucessComponent,
    FaildComponent,
    PropertyDetailComponent,
    RegisterPropertyComponent,
    UserPropertyListComponent,
    UserPropertyDetailComponent,
    ForgetPasswordComponent,
    PaymentDetailComponent,
    IndexComponent,


  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeskiModule { }
